import { TwitterHashtagButton, TwitterTimelineEmbed } from 'react-twitter-embed'
import SectionPreloader from '../common/SectionPreloader'

const TwitterBlock =({screenName, sourceType, hashtags, width, height, theme="dark"})=> {

  return (
    <div className="twitter_block">
      <div className="dummy_block">
          <div className="abs_preloader">
            <SectionPreloader color="#fff" txt="Loading Twitter.." />
          </div>
        {
          height && <TwitterTimelineEmbed
            theme={theme}
            sourceType={sourceType}
            screenName={screenName}
            options={{ height: height - 100 }}
          />
        }
      </div>
      <div className="share_buttons">
          {
            hashtags && hashtags.map((ht, i) => <TwitterHashtagButton key={'hash'+i} tag={`${ht}`} options={{size:'large',  hashtag:ht}} />)
          }
        </div>
      </div>
  )
}

export default TwitterBlock;
